export default __webpack_public_path__ + "static/media/colibriDeRaquetas.195b1825.jpg";